import httpService from "@/core/services/http.service.js";
import { SET_ALERT_MESSAGES } from "@/core/services/store/alert.module.js";

export default {
    methods: {
        /**
         * Check if appointment can be approved
         * @param {Object} appointment
         * @return {Boolean}
         */
        canApproveAppointment(appointment) {
            return appointment?.status === "PENDING";
        },

        /**
         * Approve a pending appointment
         * @param {Object} appointment
         * @return {void}
         */
        approveAppointment(appointment) {
            httpService
                .post("/api/b2b/approve/appointment/" + appointment.id)
                .then((response) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: [response.data.message],
                        errorMessages: null,
                    });
                    if (typeof this.filterCalendarEvents === "function") {
                        this.filterCalendarEvents();
                    }
                    if (this.$refs.mobileEventPopover?.isOpen) {
                        this.$refs.mobileEventPopover.close();
                        if (typeof this.emitToggleOverlay === "function") {
                            this.emitToggleOverlay();
                        }
                        this.selectedAppointment = null;
                    }
                })
                .catch((error) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: null,
                        errorMessages: [
                            error.response?.data?.message ??
                                "Failed to approve appointment",
                        ],
                    });
                });
        },
    },
};
